'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.httpInterceptorLanguage = httpInterceptorLanguage;
/*@ngInject*/
function httpInterceptorLanguage() {
    return {
        // On request success
        request: function request(config) {
            if (!config.headers) {
                config.headers = {};
            }

            config.headers['x-accept-language'] = window.localStorage.getItem('language') || 'nl';
            return config;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./common/core/httpInterceptorLanguage.js
// module id = 705
// module chunks = 0